<template>
  <b-row>
    <b-col cols="12">
      <CustomSeparator text="Resultado de Alternativa de Ubicación" />
    </b-col>
    <b-col v-if="hasResult" cols="12">
      <template v-for="(item, i) in result">
        <ResultItem :key="i" :item="item" />
        <div
          v-if="item.isThereUpdatedQuota"
          class="rb-alert rounded-bottom pr-2 px-md-3 d-flex align-items-center alert-pending"
        >
          <i class="fas fa-bell-exclamation font-24 mx-3 ml-lg-2"></i>

          <p class="font-weight-normal my-auto font-14">
            Algunas de las alternativas cuentan con cupo modificado.
          </p>
        </div>
      </template>

      <Pagination
        v-if="pagination.pageCount > 1"
        :data="pagination"
        :page-size="PAGE_SIZE"
        @pagination-go-page="paginate"
      />
    </b-col>
    <b-col v-else cols="12">
      <CustomResultNotFound text="No hay información disponible." />
    </b-col>
  </b-row>
</template>

<script>
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import ResultItem from './SearchResultItem';
import { initialPagination } from '../_utils';
import { PAGE_SIZE } from '../_config';

export default {
  name: 'LocationAlternativesSearchResult',
  components: {
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultItem,
  },
  props: {
    result: { type: Array, default: () => [], required: true },
    pagination: {
      type: Object,
      default: initialPagination,
      required: true,
    },
  },
  data: () => ({ PAGE_SIZE }),
  computed: {
    hasResult() {
      return this.result.length;
    },
  },
  methods: {
    paginate(page) {
      this.$emit('update:pagination', {
        ...this.pagination,
        currentPage: page,
      });
      this.$emit('onPageChanged', page);
    },
  },
};
</script>
<style>
.alert-pending {
  background-color: #fff5e8;

  & p,
  i {
    color: #af6708;
  }
}
.rb-alert {
  width: 100%;
  padding: 10px 0;
}
</style>
